var map = {
	"./custom/app/header/header.component": [
		40877,
		[
			"src_themes_custom_app_header_header_component_ts"
		]
	],
	"./dspace/app/header/header.component": [
		73692,
		[]
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 16722;
module.exports = webpackAsyncContext;